import axios from 'axios'
import { backendUrl } from '@/helpers/backendUrl.js'
//import router from '@/router'
import vuecookie from 'vue-cookies'

const state = {
  postalAddress: '',
  customerIds: [],
  deliveryOptions: [],
  relatedLevels: [],
};

const getters = {
  getPostalAddress: (state) => state.postalAddress,
  getCustomerIds: (state) => state.customerIds,
  getDeliveryOptions: (state) => state.deliveryOptions,
  getRelatedLevels: (state) => state.relatedLevels,
};

const actions = {
    async handleDocumentTool(context, data) {
        await axios.post(`${backendUrl()}/actionHandler`,
        {
            sessionToken: vuecookie.get('token'),
            action: data.action,
            documents: data.documents,
            userLevel: data.userLevel,
            customerId: data.customerId,
            //for email
            email_to: data.email_to,
            email_from: data.email_from,
            email_subject: data.email_subject,
            email_message: data.email_message,
            wm: data.wm,
            perm_wm_allowed: data.perm_wm_alloweds,
            //for fax
            toName: data.toName,
            toFax: data.toFax,
            fromName: data.fromName,
            fromTel: data.fromTel,
            fromFax: data.fromFax,
            subject: data.subject,
            message: data.message,
            //for post
            postAddress: data.postAddress,
            isAlternateAddress: data.isAlternateAddress,
            docLevels: data.docLevels,
            //for dont_post
            statuses: data.statuses,
            //for accept && reject all documents of a batch
            batchId: data.batchId,
            deliveryOptions: data.deliveryOptions,
            relatedLevels: data.relatedLevels,
            rejectReason: data.rejectReason,
            //for change posthouse
            newPostHouse: data.newPostHouse,
            //for notify remittance
            totalValue: data.totalValue,
            notifyDetails: data.notifyDetails,
            docInfo: data.docInfo,
            //for raise query
            queryDetails: data.queryDetails
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.dispatch('handleResponse', response, {root: true})
        })
    },
    async getPostalAddress(context, data) {
        await axios.post(`${backendUrl()}/getPostalAddress`,
        {
            sessionToken: vuecookie.get('token'),
            documents: data.documents
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setPostalAddress', response.data)
        })
    },
    async getCustomerIds(context, data) {
        await axios.post(`${backendUrl()}/getCustomerIds`,
        {
            sessionToken: vuecookie.get('token')
        },
        {
            headers: { 'Authorization': "bearer " + vuecookie.get('token') }
        })
        .then(response => {
            context.commit('setCustomerIds', response.data)
        })
    },
    async getBatchAcceptInfo(context, data) {
        await axios.post(`${backendUrl()}/getBatchAcceptInfo`,
            {
                batchId: data.batchId,
            },
            {
                headers: { 'Authorization': "bearer " + vuecookie.get('token') }
            })
            .then(response => {
                if (response.data.status) {
                    context.dispatch('handleResponse', response, {root: true})
                }
                context.commit('setDeliveryOptions', response.data.deliveryOptions)
                context.commit('setRelatedLevels', response.data.relatedLevels)
            })
    },
};

const mutations = {
  setCustomerIds: (state, customerIds) => (state.customerIds = customerIds),
  setPostalAddress: (state, postalAddress) => (state.postalAddress = postalAddress),
  setDeliveryOptions: (state, deliveryOptions) => (state.deliveryOptions = deliveryOptions),
  setRelatedLevels: (state, relatedLevels) => (state.relatedLevels = relatedLevels),
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
